import { Button, Theme, Typography, makeStyles } from '@material-ui/core'
import classNames from 'classnames'
import React from 'react'
import Scrollbars from 'react-custom-scrollbars-2'

interface ISidePanelProps {
  children?: React.ReactChild | any[] | boolean
  className?: string
  classes?: any
  header?: React.ReactChild | any[] | boolean
  // FIXME (malaoui, 2022/10/11 - 2023/04/21) make title mandatory when SidePanel is removed from ImportFromPanel and MainPanel
  title?: string
}

const SidePanel = (props: ISidePanelProps) => {
  const { header, children } = props
  const classes = useStyles()

  return (
    <div className={classNames(classes.root)}>
      {header && (
        <div className={classes.header}>
          {props.title && (
            <Typography variant="h4" className={classes.title} noWrap={true} title={props.title}>
              {props.title}
            </Typography>
          )}
          {header}
        </div>
      )}
      <div className={classes.scrollable}>
        <Scrollbars>
          <div className={classes.content}>{children}</div>
        </Scrollbars>
      </div>
    </div>
  )
}

interface ISidePanelButton {
  className?: string
  label: string
  onClick?: () => void
}
export const SidePanelButton = ({ className, label, onClick }: ISidePanelButton) => {
  const classes = useStyles()
  return (
    <Button
      disableElevation
      fullWidth
      variant="contained"
      color="primary"
      className={className ?? classes.button}
      onClick={onClick}
    >
      {label}
    </Button>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: 300,
    flexShrink: 0,
    backgroundColor: theme.palette.background.paper,
    borderTopLeftRadius: 'inherit',
    borderBottomLeftRadius: 'inherit',
    marginRight: 1,
    height: '100%',
  },
  button: {
    marginBottom: theme.spacing(4),
  },
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'inherit',
    borderTopLeftRadius: 'inherit',
    borderBottomLeftRadius: 'inherit',
  },
  header: {
    width: '100%',
    minHeight: 80,
    boxSizing: 'border-box',
    paddingRight: 12,
    paddingLeft: 12,
    paddingTop: 24,
    borderBottom: `1px solid #EBEDF3`,
    borderTopLeftRadius: 'inherit',
  },
  title: {
    fontSize: 30,
    margin: `20px 0 14px 0`,
  },
  scrollable: {
    flex: '1',
  },
}))

export { default as CheckboxesSection } from './Components/CheckboxesSection'
export { default as FilterPanelHeader } from './Components/FilterPanelHeader'
export { default as SidePanelSection, ExpansionIcon } from './SidePanelSection'
export default SidePanel
